import React from 'react';
import { GlobalRoutes } from './auto-routes';
import './styles/App.less';
import DocumentTitle from 'react-document-title';
import { i18n as i } from './i18n';


function App() {
  return (
    <div className="App">
      <DocumentTitle title={i("GS-OPENAPI")}>
        <GlobalRoutes/>
      </DocumentTitle>
    </div>
  );
}

export default App;
